export default "__VITE_ASSET__BLv94$jE__"